export default "https://cdn-static.gokick.com/assets/0ba7a9ad4dd7229a35aca69ca4183ecb31843a51/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";